import * as io from "io-ts";
import { BlockImport, BlockModel } from ".";
import { withMessage } from "io-ts-types";
import t from "../../../../../i18n";

export const BlockTextKind = withMessage(io.strict({ kind: io.literal("TEXT") }), () =>
  t("schema.block.kind"),
);

export const BlockTextData = io.type({ data: io.string });

export const BlockTextModel = io.intersection([BlockModel, BlockTextKind, BlockTextData]);

export const BlockTextImport = io.intersection([BlockImport, BlockTextKind, BlockTextData]);

export type BlockTextModelT = io.TypeOf<typeof BlockTextModel>;
export type BlockTextImportT = io.TypeOf<typeof BlockTextImport>;
